import cx from "classnames";
import React from "react";

// A simple filter which filters on provided text
export const TextFilter = (props) => {
    return (
        <input
            key={props.columnIdentifier}
            className={cx("text-filter", props.className)}
            type={"text"}
            placeholder={props.placeholder}
            onChange={(e) => props.setFilter(props.columnIdentifier, e.target.value)}
            value={props.state || ""}
            maxLength={props.maxLength || ""}
        />
    );
};
